<template>
  <div>
    <v-combobox
      :items="options"
      v-model="innerValue"
      item-text="text"
      item-value="value"
      clearable
      hide-details
      :loading="loading"
      @keypress="clearMe"
      @change="changeMe"
      :search-input.sync="search"
      v-bind="resetProps"
    >
      <!-- <template v-slot:no-data>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>
            No results matching "<strong>{{ innerValue }}</strong
            >". Press <kbd>enter</kbd> to create a new one
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template> -->
    </v-combobox>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import _ from "lodash";

export default {
  props: {
    returnObject: Boolean,
    value: [String, Number, Object],
    items: Array,
    filterType: [String],
  },
  data() {
    return {
      innerValue: this.value,
      search: null,
      loading: false,
      selected: null,
      filteredOptions: [],
    };
  },

  watch: {
   
    value(n) {
      this.innerValue = n;
    },
    innerValue(value) {
      this.$emit("input", value);
    },
    filterType(newValue) {
      if (newValue) {
        this.filteredOptions = this.options.filter(
          (item) => item.type === newValue
        );
      }
    },
    options(options) {
      this.filteredOptions = options;
    },
    search: _.debounce(async function (newSearch, oldTerm) {
      if (newSearch === oldTerm) return;
      if (!newSearch || newSearch.length < 1) return;
      if (this.loading) return;
      if (this.selected !== null) return;
      this.loading = true;
      await this.addItemOption({
        PageSize: 1000,
        PageNumber: 1,
        SearchTerm: newSearch,
      });
      this.loading = false;
      this.$emit('keyup', newSearch);
    }, 500),
  },

  async created() {
    await this.getAll();
  },

  methods: {
    ...mapActions("item", ["getAll", "addItemOption"]),
    onChange(e) {
      this.$emit("onChange", e);
    },

    clearMe() {
      this.selected = null;
    },

    changeMe(m) {
      this.selected = m;
      this.$emit("change", this.innerValue);
    },
  },

  computed: {
    resetProps() {
      return { ...this.$attrs };
    },
    ...mapState({
      item: (state) => state.item,
    }),

    itemOptions() {
      return this.item.itemOptions;
    },

    options() {
      return this.item.itemOptions
        .filter((item) => {
          if (this.filterType) {
            return item.type === this.filterType;
          } else {
            return true;
          }
        })
        .map((item) => {
          return {
            ...item,
            value: item.id,
            text: item.name + ` (${item.type})`,
          };
        });
    },
  },
};
</script>